import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { finalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetApplicationDataQueryProps = {
	applicationId: string;
};

const useGetApplicationDataQuery = ({
	applicationId,
}: useGetApplicationDataQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["applicationData", applicationId],
		() => finalService.getApplication(applicationId),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!applicationId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetApplicationDataQuery;
